import type { FaireProductEntity } from "../../entity_types/product";

export const p_s7p3cxhdhw: FaireProductEntity = {
  token: "p_s7p3cxhdhw",
  type: "product",
  name: "Elegant High-Waisted Wide-Leg Pleated Office Casual Pants",
  brandToken: "b_m4nc6munyv",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/0830fe36e5ea27f3927efd2c890472298c0ef86d3ce9a70b4acca8700b515b8a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b60df8e969e5b6d2fc7f96fd8382065d966ff4ddbec915683e96d6ec8d56d263.jpeg",
    "https://cdn.faire.com/fastly/b8b80f2af9296b20fd3cf7578565090b5d9989618a0c6c694792ba85d9e99e9b.jpeg",
    "https://cdn.faire.com/fastly/d5e8f9820bdc5c8581941dde03a42063ffaa7d649b80ec9d4197fe034a51bb36.jpeg",
    "https://cdn.faire.com/fastly/154b4c9b9fd19ed31fff824c86d155ab21a7ac3147acfc1bdb40d27f29b13bc1.jpeg",
    "https://cdn.faire.com/fastly/580d0902082cb034741fc3ad46ad0c416b932de1928b9cfe3619acc2f083a5bf.jpeg",
  ],
  priceDollars: 28.24,
  description:
    "Elegant High-Waisted Wide-Leg Pleated Office Casual Pants_RCDQ02298\n\nOur product size standards are different, please check the size information before placing an order\t\t\t\t\t\t\t\t\n\nSize Chart(Inch)\t\t\t\n\t    Waist\t      Hip\t    Length\nM \t28.35  \t45.67  \t40.94 \nL  \t30.31  \t47.64  \t41.34 \nXL\t33.46  \t50.79  \t41.93 \n2XL\t36.61  \t53.94  \t42.52 \n\nWomen shackets,crochet cardigan,cable knit sweater,ruffle dress,blouse,puff sleeve top,denim skirts,fall top,fall dress,blazer，Knit cardigan,Midi dress,Laple Shirts,Tank Top,Knit Top,High waist pants,Button down Jacket,Skirt,Ruffle blouse,Sweatshirt,hoodie,midi dress,knit sweater,2 piece set,denim jacket,plaid shirt,zip up jacket,wide leg pant,fur coat，tweed jacket,2025 Women Apparel",
  tags: [],
  msrpDollars: 56.48,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:27.834Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
